var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "            <li class=\"cell-wrapper\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">\n                <a>"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</a>\n            </li>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "            <li class=\"cell-wrapper showCat\">\n                <a class=\"showCategory\">更多 <img src=\"" + require("../../images/pos/POS-2-02.png") + "\"/></a>\n            </li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"catList\">\n    <ul class=\"nav nav-tabs category\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.dataMenuCategories : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPageInfo : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/order/MenuCategoryList.handlebars
// module id = 537
// module chunks = 0